import type { StoreOptions } from 'vuex';
import type Player from '../../dto/Player';
import axios from 'axios';
import { createStore } from 'vuex';
import User from '../../dto/User';

interface DateState {
    season: number | null;
    week: number | null;
    day: number | null;
}

interface State {
    user: User;
    date: DateState;
}

const storeOptions: StoreOptions<State> = {
    state: {
        user: new User(),
        date: {
            season: null,
            week: null,
            day: null,
        },
    },
    getters: {
        user(state): User {
            return state.user;
        },
        player(state): Player {
            return state.user.player;
        },
        userIsBannedForChat(state): boolean | undefined {
            return state.user.chat.ban.isActive;
        },
        userChatBanExpireDate(state): Date | null {
            if (!state.user.chat.ban.expireDate) {
                return null;
            }

            return new Date(state.user.chat.ban.expireDate.date);
        },
    },
    mutations: {
        loadUser(state, data) {
            state.user = User.fromData(data.data);
            window.emitter.emit('user_loaded');
        },
        loadDate(state, data: DateState) {
            state.date = data;
        },
    },
    actions: {
        loadUser({ commit }) {
            axios
                .get('/api/users/me?include=player,player.country,ignored_users,friends')
                .then(response => commit('loadUser', response.data))
                .catch((error) => {
                    if (error.response.status === 401) {
                        window.location.href = '/';
                    }
                    else {
                        throw error;
                    }
                })
            ;
        },
        loadDate({ commit }) {
            axios
                .get('/api/date')
                .then(response => commit('loadDate', response.data));
        },
    },
};

export const store = createStore<State>(storeOptions);
